<template>
  <section
    class="prizes-container"
    :class="siteVariant"
  >
    <h2><span>Prizes<sup>*</sup></span></h2>
    <PrizesList
      title="Zone Prizes"
      :prizes="prizesList"
      :footer-image-mb="`zone-prizes-${siteVariant}-mb.webp`"
      :footer-image="`zone-prizes-${siteVariant}.webp`"
      :footer-image-alt="siteVariant === 'acura' ? 'Acura ADX' : 'Honda Prologue'"
      :site-variant="siteVariant"
    />
    <PrizesList
      class="national-prizes"
      title="National Competition Prizes<sup>***</sup>"
      :prizes="nationalPrizes"
      :site-variant="siteVariant"
    >
      <template v-slot:info>
        <div class="info">
          <div class="img">
            <img
              src="@/assets/img/national-prize-info.webp"
              alt="The Cosmopolitan of Las Vegas"
            />
          </div>
          <ul class="info-list">
            <li class="first-item">
              <span class="number">12</span>
              <span>
                <span class="large-text">NATIONAL FINALISTS</span> (Regardless of zone)
              </span>
            </li>
            <li>
              <span class="icon">
                <img src="@/assets/img/airplane.svg" alt="" aria-hidden="true">
              </span>
              <span class="text">
                Airfare for TWO to Las Vegas
              </span>
            </li>
            <li>
              <span class="icon">
                <img src="@/assets/img/bed.svg" alt="" aria-hidden="true">
              </span>
              <span class="text">
                Two-night accommodations at The Cosmopolitan of Las Vegas
              </span>
            </li>
            <li>
              <span class="icon">
                <img src="@/assets/img/giftbox.svg" alt="" aria-hidden="true">
              </span>
              <span class="text">
                Welcome Gift
              </span>
            </li>
          </ul>
        </div>
      </template>
    </PrizesList>
    <div class="last-prize">
      <article>
        <p>5 – 12TH PLACE: $500</p>
        <p>{{ modifiedCredits }} Sales Credits: 4</p>
      </article>
    </div>
    <div class="disclaimers">
      <ul>
        <li>
          *Cash Prize awards paid directly to Sales Consultants are taxable to the individual
          participant. Recipients of such award payments should contact their tax advisor for
          advice. {{ brand }} Division will report awards of $600 or higher
          to the IRS and provide a 1099 to the recipient. Awards of less than $600 will not
          receive a 1099.
        </li>
        <li>
          **{{ modifiedCredits }} is Council of Sales
          {{ siteVariant === 'acura' ? 'Excellence' : 'Leadership' }}
        </li>
        <li>
          ***Must travel to and compete in National Competition to receive national prizes.
          Participants for the National Competition will be chosen from ALL valid video
          submissions regardless of Zone.
        </li>
        <li>
          ****Sales Consultant must be employed and active at {{ brand }} dealership at the
          time of the competition.
        </li>
      </ul>
      <div class="acura-img">
        <img
          v-if="siteVariant === 'acura'"
          src="@/assets/img/national-prizes-acura.webp"
          alt="White Acura ADX"
        >
        <img
          v-if="siteVariant === 'honda'"
          src="@/assets/img/national-prizes-honda.webp"
          alt="White Honda Prologue"
        >
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.prizes-container {
  background-color: $AC_Navy;

  h2 {
    font-size: clamp(29px, 83px, 6vw);
    font-weight: 500;
    color: $AC_White;
    line-height: 1.2;
    text-transform: uppercase;
    text-align-last: left;
    padding: 0 20px 24px;
    display: flex;
    align-items: baseline;
    gap: 15px;
    max-width: 1680px;
    margin: 0 auto;

    @media (min-width: 1025px) {
      padding-bottom: 70px;
    }

    &::after {
      content: '';
      flex: 1;
      height: 2px;
      background-color: $AC_Orange;
    }

    sup {
      font-size: clamp(25px, 55px, 4vw);
      font-weight: 300;
    }
  }
}

.national-prizes {
  padding: 40px 0;
  z-index: 1;

  @media (min-width: 1025px) {
    padding-top: 140px;
    padding-bottom: 70px;
  }

  .info {
    max-width: 520px;
    margin: 0 auto;
    padding: 0 16px 45px;

    .img {
      border-radius: 3px;
      overflow: hidden;
    }

    @media (min-width: 1025px) {
      display: flex;
      align-items: center;
      max-width: none;
      padding: 0 0 86px;

      .img {
        border-radius: 0 10px 10px 0;
        flex: 1 1 872px;
      }
    }

    @media (min-width: 1281px) {
      margin-top: 20px;
    }
  }

  .info-list {
    font-size: 17px;
    color: $AC_White;
    text-align: left;
    line-height: 1.4;
    padding: 35px 0 0 7px;
    display: flex;
    flex-direction: column;
    gap: 25px;

    @media (min-width: 1025px) {
      padding: 10px 3% 10px 4.5%;
      flex: 1 1 1048px;
    }

    @media (min-width: 1281px) {
      font-size: clamp(17px, 38px, 2vw);
    }

    li {
      display: flex;
      align-items: center;
      gap: 15px;

      &:not(.first-item) {
        padding-left: 15px;
      }

      @media (min-width: 1281px) {
        gap: 30px;

        &:not(.first-item) {
          padding-left: 35px;
        }
      }

      @media (min-width: 1691px) {
        gap: 50px;

        &.first-item {
          margin-bottom: 30px;
        }
      }
    }
  }

  .number {
    font-size: 63px;
    font-weight: 700;
    line-height: 1;
    letter-spacing: -5px;

    @media (min-width: 1281px) {
      font-size: clamp(63px, 153px, 8vw);
    }
  }

  .large-text {
    font-size: 25px;
    line-height: 1;
    display: block;

    @media (min-width: 1281px) {
      font-size: clamp(25px, 65px, 3.4vw);
    }
  }

  .icon {
    width: 34px;
    height: 34px;
    border: 2px solid $AC_White;
    border-radius: 10px;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;

    @media (min-width: 1281px) {
      width: 50px;
      height: 50px;
    }

    @media (min-width: 1691px) {
      width: 70px;
      height: 70px;
      padding: 10px;
    }
  }

  .text {
    flex: 1;
  }
}

.acura {
  .first-item {
    font-family: 'Avenir Book', sans-serif;
  }
}

.last-prize {
  color: $AC_White;
  line-height: 1.4;
  letter-spacing: 2px;
  padding: 0 16px;

  p {
    font-size: clamp(17px, 32px, 2vw);
    font-weight: 400;
  }

  p:first-of-type {
    font-size: clamp(26px, 48px, 3vw);
    font-weight: 700;
    text-transform: uppercase;
    margin-bottom: 5px;
  }
}

.disclaimers {
  padding-top: 35px;

  @media (min-width: 1025px) {
    padding-top: 70px;
  }

  ul {
    display: flex;
    flex-direction: column;
    gap: 28px;
    padding: 0 40px;
    max-width: 635px;
    margin: 0 auto;

    @media (min-width: 1025px) {
      margin: 0;
      padding-left: 4vw;
    }

    @media (min-width: 1660px) {
      padding-left: 160px;
    }
  }

  li {
    font-size: 15px;
    color: $AC_White;
    line-height: 1.8;
    text-align: left;

    @media (min-width: 1025px) {
      font-size: 16px;
      width: 45vw;
      max-width: 700px;
    }
  }

  .acura-img {
    margin-left: auto;

    @media (min-width: 1025px) {
      margin-top: -26vw;
      width: 53vw;
    }
  }
}
</style>

<script setup>
import { ref, computed } from 'vue';
import PrizesList from '@/components/home/PrizesList.vue';

const props = defineProps({
  siteVariant: String,
});

const modifiedCredits = computed(() => (props.siteVariant === 'acura' ? 'COSE' : 'COSL'));

const brand = computed(() => (props.siteVariant === 'acura' ? 'Acura' : 'Honda'));

const prizesList = ref([
  {
    place: '1st Place',
    reward: '1,000',
    credits: `${modifiedCredits.value}** Sales Credits: 5`,
    size: 'lg',
  },
  {
    place: '2nd Place',
    reward: '500',
    credits: `${modifiedCredits.value} Sales Credits: 3`,
    size: 'md',
  },
  {
    place: '3rd Place',
    reward: '250',
    credits: `${modifiedCredits.value} Sales Credits: 1`,
    size: 'sm',
  },
]);

const nationalPrizes = ref([
  {
    place: '1st Place',
    reward: '5,000',
    credits: `${modifiedCredits.value} Sales Credits: 10`,
    size: 'lg',
  },
  {
    place: '2nd Place',
    reward: '3,000',
    credits: `${modifiedCredits.value} Sales Credits: 8`,
    size: 'md',
  },
  {
    place: '3rd Place',
    reward: '2,000',
    credits: `${modifiedCredits.value} Sales Credits: 6`,
    size: 'sm',
  },
  {
    place: '4th Place',
    reward: '1,000',
    credits: `${modifiedCredits.value} Sales Credits: 4`,
    size: 'xs',
  },
]);
</script>
